import type { DashboardScoreDiagnostic } from '@/core/domain/dashboard/DashboardScoreDiagnostic'
import type { IDashboardRepository } from '@/core/domain/dashboard/IDashboardRepository.ts'

export class FetchDashboardClassroomScoreDiagnosticResultsUseCase {
  private readonly dashboardRepository: IDashboardRepository

  constructor(dashboardRepository: IDashboardRepository) {
    this.dashboardRepository = dashboardRepository
  }

  async execute(
    schoolId: number,
    schoolPeriodId: number,
    classroomId: number,
    taskId: number
  ): Promise<DashboardScoreDiagnostic[]> {
    return await this.dashboardRepository.fetchDashboardScoreDiagnosticResults(
      schoolId,
      schoolPeriodId,
      classroomId,
      taskId
    )
  }
}
